///////////////////////////////////////////////////////////////////
//
// Event Listeners
//
///////////////////////////////////////////////////////////////////

(function() {
  document.addEventListener('turbolinks:load', (e) => {
    if (document.querySelector('.js-add-eligibility-item')) {
      const addFieldsLink = document.querySelector('.add_fields');

      // conditionally render answer_options field and apply event
      // listeners to persisted eligibility items on page load
      document.querySelectorAll('.js-eligibility-item-answers').forEach((item, i) => {
        const answerInputFields = new AnswerInputFields(item);

        if (answerInputFields.dropdownTypeField.checked) {
          displayAnswerOptionsField(answerInputFields);
        } else if (answerInputFields.dateTypeField.checked) {
          displayComparisonWindowField(answerInputFields);
        }

        answerInputFields.applyRadioButtonEventListeners();
      });

      // when a new eligibility item form is added ('.add_fields' link is clicked),
      // apply event listener to its answer_type radio buttons
      addFieldsLink.addEventListener('click', function() {
        // get answer fields in newly added provider eligibility item form
        const allAnswerFields = document.querySelectorAll('.js-eligibility-item-answers'),
              newAnswerFields = allAnswerFields[allAnswerFields.length - 1],
              answerInputFields = new AnswerInputFields(newAnswerFields);

        answerInputFields.applyRadioButtonEventListeners();
      });
    }
  });



  ///////////////////////////////////////////////////////////////////
  //
  // Constructors
  //
  ///////////////////////////////////////////////////////////////////

  function AnswerInputFields(itemAnswerFields) {
    this.answerOptionsDiv      = itemAnswerFields.querySelector('.js-answer-options');
    this.answerOptionsField    = itemAnswerFields.querySelector('.js-answer-options-text-area');
    this.dateTypeField         = itemAnswerFields.querySelector('[value=date]');
    this.dropdownTypeField     = itemAnswerFields.querySelector('[value=dropdown]');
    this.comparisonWindowDiv   = itemAnswerFields.querySelector('.js-comparison-window');
    this.comparisonNumberField = itemAnswerFields.querySelector('.js-comparison-number-field');
    this.radioButtons          = itemAnswerFields.querySelectorAll('[type=radio]');
  }



  ///////////////////////////////////////////////////////////////////
  //
  // Prototype Definitions
  //
  ///////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////
  //
  // Description - Apply click event listener to
  //               constructor object's radio buttons
  //
  AnswerInputFields.prototype.applyRadioButtonEventListeners = function() {
    // store initial constructor value of 'this' for correct
    // object reference inside of forEach block below
    const answerInputFieldsObject = this;

    answerInputFieldsObject.radioButtons.forEach((item, i) => {
      item.addEventListener('click', function() {
        hideAnswerFields(answerInputFieldsObject);

        if (answerInputFieldsObject.dropdownTypeField.checked) {
          displayAnswerOptionsField(answerInputFieldsObject);
        } else if (answerInputFieldsObject.dateTypeField.checked) {
          displayComparisonWindowField(answerInputFieldsObject);
        }
      });
    });
  };



  ///////////////////////////////////////////////////////////////////
  //
  // Callbacks
  //
  ///////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////
  //
  // Description - Display answer_options div
  //               and make text area a required field
  //
  function displayAnswerOptionsField(answerInputFieldsObj) {
    // display answer_options text_area
    answerInputFieldsObj.answerOptionsDiv.classList.remove('d-none');
    // set required: true on answer_options text_area
    answerInputFieldsObj.answerOptionsField.required = true;
  }

  ///////////////////////////////////////////////
  //
  // Description - Display comparison window div
  //
  function displayComparisonWindowField(answerInputFieldsObj) {
    // display comparison window input field
    answerInputFieldsObj.comparisonWindowDiv.classList.remove('d-none');
  }

  ///////////////////////////////////////////////
  //
  // Description - Hide answer-options/comparison-window divs,
  //               set input field's required value to false,
  //               and reset its value to an empty string
  //
  function hideAnswerFields(answerInputFieldsObj) {
    // hide answer_options/comparison_window_years divs
    if (!answerInputFieldsObj.answerOptionsDiv.classList.contains('d-none')) {
      answerInputFieldsObj.answerOptionsDiv.classList.add('d-none');
    } else if (!answerInputFieldsObj.comparisonWindowDiv.classList.contains('d-none')) {
      answerInputFieldsObj.comparisonWindowDiv.classList.add('d-none');
    }

    // reset required: false on associated answer fields
    answerInputFieldsObj.answerOptionsField.required = false;
    answerInputFieldsObj.comparisonNumberField.required = false;
    // reset values on associated answer fields
    answerInputFieldsObj.answerOptionsField.value = '';
    answerInputFieldsObj.comparisonNumberField.value = null;
  }
}());
